/**
 * 买家端横幅/Banner API（对接真实后端 /api/buyer/banner）
 *
 * 注意：买家端请求封装（@/api/request）暴露的是命名导出 get/post/put/del，
 * 没有 admin 那样的默认 request 函数，故此处与 inquiry.ts 保持一致使用命名导入。
 */
import { get } from '@/api/request';

/** Banner 视图对象 */
export interface BannerVO {
  id: string;
  title: string;
  /** 英文标题（EN 模式展示；空则回退中文） */
  titleEn?: string;
  imageUrl?: string;
  linkUrl?: string;
  sort: number;
}

/** Banner 列表 30s 短缓存：合并 dev StrictMode 双发与多组件共享，减少重复请求 */
let bannerCache: { at: number; p: Promise<BannerVO[]> } | null = null;
const BANNER_TTL_MS = 30_000;

/** Banner 列表：GET /buyer/banner */
export function listBanners() {
  const fresh = bannerCache && Date.now() - bannerCache.at < BANNER_TTL_MS;
  if (fresh) return bannerCache!.p;
  const p = get<BannerVO[]>('/buyer/banner').catch((err) => {
    bannerCache = null; // 失败不缓存，下次重试
    throw err;
  });
  bannerCache = { at: Date.now(), p };
  return p;
}

export const bannerApi = {
  list: listBanners,
};

export default bannerApi;
